// eslint-disable-next-line max-classes-per-file
const q = require('queried');
const ajax = require('component-ajax');
const on = require('emmy/on');
const domify = require('domify');
const AdvertButton = require('../advert-button');

class FeedLoader {
  constructor({
    buttons, feed, onRender, refreshLazyImages,
  }) {
    this.page = 1;
    this.refreshLazyImages = refreshLazyImages;
    this.AdButton = new AdvertButton();
    this.buttons = buttons;
    this.feed = feed;
    this.onRender = onRender;
    this.url = `${window.location.pathname}${window.location.search}`;
    if (window._metricsConfig && window._metricsConfig.item) {
      this.itemSlug = window._metricsConfig.item.slug;
    } else {
      this.itemSlug = null;
    }

    this.bindEvents();

    this.pageClick = this.pageClick.bind(this);
    this.prevClick = this.prevClick.bind(this);
    this.nextClick = this.nextClick.bind(this);
    this.renderFeed = this.renderFeed.bind(this);
    this.initRequest = this.initRequest.bind(this);

    this.initRequest();

    // new request when url changes
    const observeUrlChange = () => {
      let oldHref = document.location.href;
      const body = document.querySelector('body');
      const observer = new MutationObserver(() => {
        if (oldHref !== document.location.href) {
          oldHref = document.location.href;
          this.initRequest();
        }
      });
      observer.observe(body, { childList: true, subtree: true });
    };

    window.addEventListener('load', observeUrlChange);
  }

  initRequest() {
    const prevButton = document.querySelector('.feed-pagination__prev');
    const nextButton = document.querySelector('.feed-pagination__next');

    prevButton.addEventListener('click', () => this.prevClick());
    nextButton.addEventListener('click', () => this.nextClick());

    this.update({
      data: this.getData(),
      callback: (response) => {
        if (response.num_pages) {
          this.pageCount = response.num_pages;

          const paginationWrapper = document.querySelector('.feed-pagination__buttons');

          const prevBtns = document.querySelectorAll('.feed-pagination__button');

          if (prevBtns.length) {
            paginationWrapper.innerHTML = '';
          }

          for (let i = 0; i < response.num_pages; i++) {
            paginationWrapper.innerHTML += `<div class="feed-pagination__button feed-pagination__button-${i + 1}">${i + 1}</div>`;
          }

          const btns = document.querySelectorAll('.feed-pagination__button');

          btns[0].insertAdjacentHTML('afterend', '<span class="feed-pagination__dots-1">...</span>');
          btns[response.num_pages - 1].insertAdjacentHTML('beforebegin', '<span class="feed-pagination__dots-2">...</span>');

          btns.forEach((button) => {
            button.addEventListener('click', this.pageClick);
          });

          this.buttons.forEach((button) => {
            button.classList.remove('preloading');
          });

          if (!response.has_more) {
            this.buttons.forEach((button) => {
              button.classList.add('hide-text');
            });
          } else {
            this.buttons.forEach((button) => {
              button.classList.remove('hide-text');
            });
          }
          if (this.page) {
            this.checkActiveButton();
          }
          prevButton.style.visibility = 'visible';
          nextButton.style.visibility = 'visible';
          this.checkButtonsView();
        } else {
          prevButton.style.visibility = 'hidden';
          nextButton.style.visibility = 'hidden';
        }
      },
    });
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      on(button, 'click', () => this.handleClick());
    });
    if (this.feed.hasAttribute('data-load-more')) {
      this.url = this.feed.getAttribute('data-load-more');
    }
  }

  pageClick(e) {
    const pageNumber = parseInt(e.target.classList[1].match(/\d+/), 10);
    this.page = pageNumber;

    this.buttons.forEach((button) => {
      button.classList.add('preloading');
    });

    this.checkActiveButton();

    this.update({ data: { page: pageNumber }, callback: this.renderFeed });
    this.checkButtonsView();
  }

  checkActiveButton() {
    const activeButton = document.querySelector('.feed-pagination__button-active');

    if (activeButton) {
      activeButton.classList.remove('feed-pagination__button-active');
    }

    document.querySelector(`.feed-pagination__button-${this.page}`)
      .classList.add('feed-pagination__button-active');
  }

  prevClick() {
    if (this.page === 1) return;
    this.page -= 1;

    this.checkActiveButton();

    this.update({ data: { page: this.page }, callback: this.renderFeed });
    this.checkButtonsView();
  }

  nextClick() {
    if (this.page === this.pageCount) return;
    this.page += 1;

    this.checkActiveButton();

    this.update({ data: { page: this.page }, callback: this.renderFeed });
    this.checkButtonsView();
  }

  checkButtonsView() {
    if (this.pageCount < 8) return;
    const btns = document.querySelectorAll('.feed-pagination__button');
    const firstDots = document.querySelector('.feed-pagination__dots-1');
    const secondDots = document.querySelector('.feed-pagination__dots-2');

    btns.forEach((button) => {
      button.style.display = 'none';
    });
    firstDots.style.display = 'flex';
    secondDots.style.display = 'flex';

    btns[0].style.display = 'flex';
    btns[btns.length - 1].style.display = 'flex';
    btns[this.page - 1].style.display = 'flex';

    if (this.page < 5) {
      for (let i = 0; i < 5; i++) {
        btns[i].style.display = 'flex';
      }
      firstDots.style.display = 'none';
      return;
    }

    if (this.page > (this.pageCount - 4)) {
      for (let i = this.pageCount - 1; i > this.pageCount - 6; i--) {
        btns[i].style.display = 'flex';
      }
      secondDots.style.display = 'none';
      return;
    }

    btns[this.page - 2].style.display = 'flex';
    btns[this.page].style.display = 'flex';
  }

  handleClick() {
    this.page++;
    this.checkActiveButton();
    this.checkButtonsView();

    this.update({ data: this.getData(), callback: this.renderFeed });
  }

  update({ data, callback }) {
    this.buttons.forEach((button) => {
      button.classList.add('preloading');
    });

    ajax({
      data: data.page !== 1 ? data : {},
      url: this.url,
      success: callback,
    });
  }

  renderFeed(response) {
    const rendered = domify(this.renderResponse(response));
    this.feed.innerHTML = '';
    this.feed.appendChild(rendered);
    if (this.onRender) {
      this.onRender();
    }
    if (this.refreshLazyImages) {
      this.refreshLazyImages();
    }
    this.AdButton.update();
    this.buttons.forEach((button) => {
      button.classList.remove('preloading');
    });

    // Replacement for the block is not all on the object page. Not of great importance
    if (window.kudago && window.kudago.isItemPage) {
      const container = document.querySelector('.infiniteFeed-container');
      if (container) {
        const hederEls = container.querySelectorAll('h2');
        hederEls.forEach((item) => {
          const content = item.innerHTML;
          const h3 = document.createElement('h3');
          h3.classList.add(item.classList[0]);
          h3.innerHTML = content;
          item.replaceWith(h3);
        });
      }
    }

    if (!response.has_more) {
      this.buttons.forEach((button) => {
        button.classList.add('hide-text');
      });
    } else {
      this.buttons.forEach((button) => {
        button.classList.remove('hide-text');
      });
    }

    document.querySelector('.page-feed').scrollIntoView();
    window.scrollTo(0, window.scrollY - 100);
  }

  postProcessData(data) {
    let feed = data.feed || [];

    if (this.itemSlug) {
      // feed-loading may be called from both: mix & item
      // but when we call "endless" feed for item - we must filter it from item itself
      //
      // also, thats why server answer with 31 items (if we send request with "from_item" param)
      // so we must slice answer to 30 items anyway
      feed = feed.filter((feedItem) => !feedItem.includes(this.itemSlug)).slice(0, 30);
    }

    return feed;
  }

  renderResponse(response) {
    const feed = this.postProcessData(response);
    return feed.join('');
  }

  getData() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('page')) {
      this.page = Number(searchParams.get('page'));
    }
    const data = { page: this.page };
    if (this.itemSlug) {
      data.from_item = true;
    }
    return data;
  }
}

class SearchFeedLoader extends FeedLoader {
  renderResponse(response) {
    const wrapped = response.results.map((item) => `
      <article class="post post-search">
        ${item}
      </article>
    `);

    return wrapped.join('');
  }

  getData() {
    const searchInArchive = q('.search-archive-input').checked;

    return {
      page: this.page,
      q: q('.page-header-search-input').value,
      include_inactual: searchInArchive ? 1 : 0,
    };
  }
}

module.exports = {
  FeedLoader,
  SearchFeedLoader,
};
